module.exports = __webpack_public_path__ + "static/media/img20.3a3fb766.jpg";